module.exports = "\n    <div class=\"main-wrapper min-vh position-relative\">\n        <router-outlet></router-outlet>\n    </div>\n"